import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import JoditEditor from "../../components/joditEditor";
import CustomButton from "../../components/customButton";
import AppLoader from "../../components/appLoader";
import { openSnackAlert } from "../../helper";
import useAdminSettings from "../../zustand/useAdminSettingsStore";

// Helper function to decode HTML entities
const decodeHtml = (html) => {
  if (!html) return "";
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

const PrivacyPolicy = () => {
  const [policyContent, setPolicyContent] = useState("");

  // Zustand store
  const { 
    adminSettings, 
    isLoading, 
    updateSettings: updateSettingsStore
  } = useAdminSettings();

  // Load existing data and decode HTML entities
  useEffect(() => {
    if (adminSettings?.privacyPolicy) {
      const decodedContent = decodeHtml(adminSettings.privacyPolicy);
      setPolicyContent(decodedContent);
    }
  }, [adminSettings]);

  const handleSave = async () => {
    if (!adminSettings?._id) {
      return openSnackAlert("Settings not found. Please refresh the page.", "error");
    }

    if (!policyContent || policyContent.trim() === "" || policyContent === "<p><br></p>") {
      return openSnackAlert("Please enter privacy policy", "error");
    }

    // Keep existing settings and only update privacy policy
    const settingsData = {
      privacyPolicy: policyContent,
    };

    const success = await updateSettingsStore(settingsData);
    
    if (success) {
      openSnackAlert("Privacy Policy updated successfully!", "success");
    }
  };

  return (
    <Box>
      <AppLoader isVisible={isLoading} />
      <Typography variant="h5" mb={2}>
        Privacy Policy
      </Typography>

      <Box mb={3}>
        <JoditEditor
          value={policyContent}
          onChange={setPolicyContent}
          placeholder="..."
        />
      </Box>

      <Box display="flex" justifyContent="flex-end" mt={3}>
        <CustomButton
          btnLabel="Update Privacy Policy"
          variant="webbutton"
          handlePressBtn={handleSave}
        />
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;

